$(function(){ 
    // $('.offer-banner').slick({
    // speed: 10000,
    // autoplay: true,
    // autoplaySpeed: 0,
    // cssEase: 'linear',
    // slidesToShow: 2,
    // slidesToScroll: 1,
    // infinite: true,
    // swipeToSlide: true,
    // centerMode: true,
    // arrows: false,
    // dots: false,
    //      responsive: [
    //         {
    //           breakpoint: 750,
    //           settings: {
    //             slidesToShow: 1,
    //             centerMode: false,
    //             slidesToScroll: 1
    //           }
    //         },
    //         {
    //           breakpoint: 480,
    //           settings: {
    //             slidesToShow: 1,
    //             centerMode: false,
    //             slidesToScroll: 1
    //           }
    //         }
    //       ]
    // });


    $('.dev_imageWrap').slick({
      autoplaySpeed: 0,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      swipeToSlide: true,
      arrows: true,
      dots: false
    });


    $('#dev_tabs-nav li:first-child').addClass('active');
     $('.dev_tab-content').hide();
     $('.dev_tab-content:first').show();
  
     // Click function
     $('#dev_tabs-nav li').click(function(){
       $('#dev_tabs-nav li').removeClass('active');
       $(this).addClass('active');
       $('.dev_tab-content').hide();
  
       var activeTab = $(this).find('a').attr('href');
       $(activeTab).fadeIn();
       return false;
     });


    $(document).on('click','.dev_quickadd', function(event){
      console.log('clicked');
      var _thisElem = $(this);
      var dev_btnHTML = $(this).find('.dev_quickAddBtn').html();
      var variantId = $(this).find('.dev_quickAddBtn').attr('dev_varID');
      event.preventDefault(); //don't do the form processing..
      $(this).find('.dev_quickAddBtn').html('Adding <img src="https://cdn.shopify.com/s/files/1/0607/0765/t/39/assets/icons8-loading-circle.gif?v=1654511875">');
      var params = { quantity: 1, id: variantId};
      console.log(params); //what things we are posting..
      setTimeout(function() {
        $.ajax({
          type: "POST",
          url:'/cart/add.js',
          data: params,
          dataType: "json",
          success:  function() {
            //document.location.href = "/cart" 
            _thisElem.find('.dev_quickAddBtn').html('Added <img src="https://cdn.shopify.com/s/files/1/0607/0765/t/39/assets/icons8-check-48_copy.png?v=1654513140">');
            setTimeout(function() {
              _thisElem.find('.dev_quickAddBtn').html(dev_btnHTML);
             },1500);
            
            
            jQuery.getJSON('/cart.js', function(cart) {
              $('.js-cart-count').html(cart.item_count);
            });

          },
          error: function() {
            console.log('error handling here');
          }
        });
      },1000); 
    });

     $(document).on('click', '.devCartBag' , function(){
      $(this).siblings('.prod-image').find('.product-listing__quickview-trigger').trigger('click');
    });

     $(document).on('click', '.video-btn' , function(){
       $('.flickity-page-dots .dot:last-child').trigger('click');
     });

      var dev_proName = $('.dev_similarProducts .dev_productItem').eq(0).find('a').attr('data-protitle');
      $('.dev_colorOptionLabel span').text(dev_proName);
      $('.dev_similarProducts .dev_productItem').eq(0).addClass('dev_activePro');

      $('.dev_productItem').mouseover(function(){
        $(this).addClass('dev_activePro');
        $(this).siblings('.dev_productItem').removeClass('dev_activePro');
        var _thisName = $(this).find('a').attr('data-protitle');
        $('.dev_colorOptionLabel span').text(_thisName);
     });

      $(document).on('click','.dev_disableBtn', function(e){
       e.preventDefault();
       $('.bis-reset').trigger('click');
     });
   
});